import { ISignInMagicLinkXP } from "@faire/web-api/indigofair/seo/ISignInMagicLinkXP";
import { ENABLE_MFA_TIMING_XP_241018 } from "@faire/web-api/indigofair/settings/ENABLE_MFA_TIMING_XP_241018";
import { ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024 } from "@faire/web-api/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024";
import { ENABLE_SIGN_IN_IMPROVEMENTS_UX_TEST_092024 } from "@faire/web-api/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_UX_TEST_092024";

import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingMfaTimingXP = (): boolean =>
  useSetting(ENABLE_MFA_TIMING_XP_241018, false);

export const useAssignSettingSignInMagicLinkImprovements = () =>
  useAssignSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024);

const useSettingMagicLinkSignInImprovements = (): ISignInMagicLinkXP =>
  useSetting(
    ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024,
    ISignInMagicLinkXP.Bucket.CONTROL
  );

export const useIsNewMagicLinkExperience = (
  variant?: ISignInMagicLinkXP
): boolean => {
  const isMagicLink = useSettingMagicLinkSignInImprovements();
  if (variant) {
    return isMagicLink === variant;
  }
  return isMagicLink !== ISignInMagicLinkXP.Bucket.CONTROL;
};

export const useAssignSettingSignInUIImprovements = () =>
  useAssignSetting(ENABLE_SIGN_IN_IMPROVEMENTS_UX_TEST_092024);

const useSettingSignInUIImprovements = (): boolean =>
  useSetting(ENABLE_SIGN_IN_IMPROVEMENTS_UX_TEST_092024, false);

export const useSignInImprovementsUIRedesign = (): boolean => {
  //TODO: add other tests here
  const isUIChange = useSettingSignInUIImprovements();
  return isUIChange;
};
